import DabangBanner from "../../../../src/events/2022/01/dabang-banner/main";
import * as React from 'react';
export default {
  DabangBanner,
  React
};